<template>
  <div class="pages">
    <img src="/static/service/buy/banner-lc@3x.png" class="tImg" />
    <div class="b_pic_text">
      购买流程
    </div>
    <div
      id="process"
      class="process"
      :class="{ isFixed: searchBarFixed }"
    >
      <div
        class="step"
        :class="{ isActived: actived === index }"
        @click="changeStep(index)"
        v-for="(item, index) in newsList"
        :key="item.id"
      >
        <span>{{ item.title }}</span>
      </div>
    </div>
    <div class="content" id="scroll-box">
      <div class="dis">
        <img
          class="box"
          style="width: 100%;"
          :src="info.thumb"
        />
      </div>
      <div class="no-data" v-if="!newsList.length">{{ $t('main.noData') }}</div>
      <div class="btn_box">
        <div
          v-if="actived !== 0 && newsList.length"
          @click="changeStep(actived - 1)"
          class="btn"
        >
        {{ $t('main.beforeP') }}
        </div>
        <div
          v-if="actived !== newsList.length - 1 && newsList.length"
          @click="changeStep(actived + 1)"
          class="btn active_btn"
        >
        {{ $t('main.nextP') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getContents, getContentsDetail
} from "@/api";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      categoryInfo: {},
      newsList: [],
      searchBarFixed: false,
      actived: 0,
      page: 1,
      limit: 10,
      total: 1000,
      steps: [],
      cat_id: "",
      info: {}
    };
  },
  watch: {
    "$store.state.siteInfo": function() {
      this.init();
    },
    "$store.state.tabs": function() {
      this.init();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (localStorage.getItem("navTabs_" + Cookies.get("siteInfo"))) {
        let tabs = this.treeToArray(JSON.parse(localStorage.getItem("navTabs_" + Cookies.get("siteInfo"))));
        let catInfo = tabs.find(item => {
          return item.list_template == "category_steps";
        });
        if (catInfo) {
          this.cat_id = catInfo.id;
          this.getContentList();
        }
      }
    },
    getContentList() {
      // 获取对应内容
      let params = {
        req: {
          cat_id: this.cat_id,
          page: 1,
          limit: 10000,
          order: "orderby asc"
        }
      };
      getContents(params).then(({ rsp, data }) => {
        if (rsp.code === 0) {
          this.newsList = data.list;
          if(data.list.length) this.getDetail(data.list[0].id);
        }
      });
    },
    treeToArray(data) {
      let res = [];
      function auxiliary(arr) {
        arr.forEach(item => {
          let obj = {
            id: item.id,
            pid: item.pid,
            model_id: item.model_id,
            is_menu: item.is_menu,
            is_post: item.is_post,
            name: item.name,
            image: item.image,
            identification: item.identification,
            list_template: item.list_template,
            article_template: item.article_template,
            child:null
          };
          // 如果是产品则添加 list_template 和 article_template
          if (item.model_id == 23 && item.pid == 0) {
            obj.list_template = 'category_product';
            obj.article_template = 'detail_product';
          }
          if (item.model_id == 23 && item.pid != 0) {
            obj.list_template = 'category_product_more';
            obj.article_template = 'detail_product';
          }

          res.push(obj);
          if (item.child && item.child.length) {
            auxiliary(item.child);
          }
        });
      }
      auxiliary(data);
      return res;
    },
    getDetail(id) {
      let params = {
        req: {
          id: id
        }
      };
      getContentsDetail(params).then(res => {
        if(res.rsp.code === 0) {
          this.info = res.data;
        }
      });
    },
    jump() {
      let scrollItem = document.getElementById("process");
      // 锚点对应的模块与最近的一个具有定位的祖宗元素顶部的距离
      this.offsetTop = scrollItem.offsetTop;
      window.scrollTo({
        top: scrollItem.offsetTop,
        behavior: "smooth"
      });
    },
    changeStep(index) {
      this.actived = parseInt(index);
      this.getDetail(this.newsList[index].id);
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // var offsetTop = document.querySelector("#process").offsetTop;
      if (scrollTop > 720) {
        this.searchBarFixed = true;
      } else {
        this.searchBarFixed = false;
      }
    },
    handleTimeToString(v) {
      let date = new Date(parseInt(v) - 1000);
      let Y = date.getFullYear();
      let M = date.getMonth() + 1;
      M = M > 9 ? M : "0" + M;
      let D = date.getDate();
      D = D > 9 ? D : "0" + D;
      let H = date.getHours();
      H = H > 9 ? H : "0" + H;
      let m = date.getMinutes();
      m = m > 9 ? m : "0" + m;
      let s = date.getSeconds();
      s = s > 9 ? s : "0" + s;
      return `${Y}-${M}-${D} ${H}:${m}:${s}`;
    }
  }
};
</script>

<style scoped lang="less">
.pages {
  min-height: 100%;
  background-color: #fff;

  .tImg {
    width: 100%;
  }
  .b_pic_text {
    position: relative;
    bottom: 9rem;
    margin: 0 auto -4.8rem;
    font-family: YouSheBiaoTiHei,serif;
    font-size: 3.5rem;
    font-weight: 400;
    text-align: center;
    font-style: italic;
    color: white;
    background-color: rgba(0,0,0,.5);
    border-radius: 0.5rem;
  }

  .isFixed {
    position: fixed;
    top: 0;
    z-index: 999;
    width: 100%;
  }

  .process {
    height: 30px;
    line-height: 30px;
    background-color: #f2f2f2;

    .step {
      color: #FFF;
      float: left;
      padding: 0 20px;
      margin: 0 20px 0 0;
      min-width: 100px;
      font-size: 1.1428rem;
      text-align: center;
      border-radius: 0.2rem;
      cursor: pointer;
      position: relative;
      background: #B8B0D4;
      &:hover {
        background: #635796;
        color: #FFF;

        &:before {
          content: '';
          position: absolute;
          bottom: -5px;
          left: calc(50% - 2.5px);
          width: 10px;
          height: 10px;
          background: #635796;
          transform: rotate(45deg);
        }
      }
      &:not(:last-child):after {
        content: '>';
        float: right;
        width: 10px;
        color: #635796;
        right: -15px;
        position: absolute;
      }
    }
    .isActived {
      background: #635796;

      &:before {
        content: '';
        position: absolute;
        bottom: -5px;
        left: calc(50% - 2.5px);
        width: 10px;
        height: 10px;
        background: #635796;
        transform: rotate(45deg);
      }
    }
    .icon {
      flex: 1;
      text-align: center;
    }
  }

  .content {
    .dis {
      margin: 0 -0.9375rem;
    }

    .no-data {
      margin-bottom: 10px;
      width: 100%;
      height: 80px;
      line-height: 80px;
      text-align: center;
      border: 1px solid #f5f5f5;
    }

    .box {
      width: calc(100% / 3);
      display: inline-block;
      padding: 0 20px;
      cursor: pointer;

      .oImg {
        width: 100%;
        height: 15.625rem;
      }
    }
  }
  .btn_box {
    display: flex;
    align-items: center;
    justify-content: center;

    .btn {
      border: 1px solid #635796;
      background: #635796;
      color: #ffffff;
      padding: .5rem 1rem;
      margin: 1.5rem;
      border-radius: 5px;

      &:hover {
        cursor: pointer;
      }
    }
    .active_btn {
      background: #635796;
      color: #fff;
    }
  }
  @media screen and (max-width: 1400px) {
    .process {
      padding: 0 2%;
    }
    .content {
      padding: 3.25rem 2%;
    }
  }
  @media screen and (min-width: 1400px) {
    .process {
      padding: 0 10%;
    }
    .content {
      padding: 3.25rem 10%;
    }
  }
  @media screen and (min-width: 1700px) {
    .process {
      padding: 0 15%;
    }
    .content {
      padding: 3.25rem 15%;
    }
  }
}
</style>
